export const tokenKeyLocalStorage = 'twitter_accessToken';
export const userDataKeyLocalStorage = 'twitter_userData';

export const saveTokenToLocalStorage = token => {
  localStorage.setItem(tokenKeyLocalStorage, token);
};
export const getTokenFromLocalStorage = () => {
  const accessToken = localStorage.getItem(tokenKeyLocalStorage);
  return accessToken;
};
export const clearTokenFromLocalStorage = () => {
  return localStorage.removeItem(tokenKeyLocalStorage);
};

////////////////

export const saveAuthDataToLocalStorage = (token, userData) => {
  localStorage.setItem(tokenKeyLocalStorage, token);
  localStorage.setItem(userDataKeyLocalStorage, userData);
};
export const getAuthDataFromLocalStorage = () => {
  const accessToken = localStorage.getItem(tokenKeyLocalStorage);
  const userData = localStorage.getItem(userDataKeyLocalStorage);
  return { accessToken, userData };
};
export const clearAuthDataFromLocalStorage = () => {
  localStorage.removeItem(tokenKeyLocalStorage);
  localStorage.removeItem(userDataKeyLocalStorage);
};

////////////////

const imagePathKeyLocalStorage = 'imagePath';
const publicTargetURLKeyLocalStorage = 'publicTargetURL';

export const saveDefaultTweetToLocalStorage = (imagePath, publicTargetURL) => {
  localStorage.setItem(imagePathKeyLocalStorage, imagePath);
  localStorage.setItem(publicTargetURLKeyLocalStorage, publicTargetURL);
};
export const getDefaultTweetFromLocalStorage = () => {
  const imagePath = localStorage.getItem(imagePathKeyLocalStorage);
  const publicTargetURL = localStorage.getItem(publicTargetURLKeyLocalStorage);
  return { imagePath, publicTargetURL };
};
export const clearDefaultTweetFromLocalStorage = () => {
  localStorage.removeItem(imagePathKeyLocalStorage);
  localStorage.removeItem(publicTargetURLKeyLocalStorage);
};
